/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";


export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;


export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;


  export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  background-color:#FFF; 
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;